import { useApiQuery } from "./useApiQuery";
import {
  getCities,
  getDealerInventory,
  getDealers,
  getOems,
  getVehicleInventoryBreakdowns,
  getVehicleInventorySummary,
  inventoryOptionLoaders,
} from "../api/vehicleInventory.api";

const keyOf = (obj) => JSON.stringify(obj);

// Enable once OEM/Dealer/City APIs implement search + page and return results/next.
const SERVER_SIDE_FILTER_OPTIONS = false;

export function useVehicleInventorySummary(filters = {}) {
  return useApiQuery((opts) => getVehicleInventorySummary({ ...filters, ...opts }), keyOf(filters));
}

export function useVehicleInventoryBreakdowns(filters = {}, { limit = 6 } = {}) {
  return useApiQuery(
    (opts) => getVehicleInventoryBreakdowns({ ...filters, limit, ...opts }),
    keyOf({ ...filters, limit }),
  );
}

export function useDealerInventory({ sort, page, pageSize, ...filters }) {
  return useApiQuery(
    (opts) => getDealerInventory({ sort, page, pageSize, ...filters, ...opts }),
    keyOf({ sort, page, pageSize, ...filters }),
  );
}

/**
 * Dropdown options (value = slug):
 *   OEM    → /api/vehicles/oem/
 *   Dealer → /api/vehicles/dealer/
 *   City   → /api/geographies/geography/cities/
 */
export function useInventoryFilterOptions({ serverSide = SERVER_SIDE_FILTER_OPTIONS } = {}) {
  const result = useApiQuery(async (opts) => {
    if (serverSide) return {};
    const [oems, dealers, cities] = await Promise.all([getOems(opts), getDealers(opts), getCities(opts)]);
    return { oems, dealers, cities };
  }, `filter-options:${serverSide}`);
  return { ...result, loaders: serverSide ? inventoryOptionLoaders : null };
}
